import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_SUBSIDY_DATE_EDIT } from '../../constants/formKeys';
import {
  getClassifiersSubsidyDateChange,
  getClassifiersSubsidyDateItem,
  getClassifiersSubsidyDateItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { subsidyDate } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterSubsidyDateTitle',
  formKey: FORM_CLASSIFIERS_SUBSIDY_DATE_EDIT,
  fields: [
    {
      name: subsidyDate.VALUE,
      label: 'fieldSubsidyDate',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierSubsidyDate,
  changeAction: actions.changeClassifierSubsidyDate,
  getChangeSelector: getClassifiersSubsidyDateChange,
  getItemSelector: getClassifiersSubsidyDateItem,
  getInitialValues: (state) => getClassifiersSubsidyDateItemData(state)?.toJS(),
});
